<template>
  <div>
    <!-- 短信日志 -->
    <el-form v-model="queryData">
      <el-row>
        <el-input
          v-model.trim="queryData.model.mobile"
          style="width: 200px; margin: 0 0 0 10px"
          placeholder="手机号"
          clearable
          @clear="clear"
        />
        <el-select
          v-model="queryData.model.status"
          placeholder="发送状态"
          style="margin: 0 0 0 10px; width: 200px"
          clearable
          @clear="clear"
        >
          <el-option label="成功" value="0">成功</el-option>
          <el-option label="失败" value="-1">失败</el-option>
        </el-select>
        <el-button
          class="search"
          type="primary"
          style="margin: 0 0 0 10px"
          @click="search"
        >搜索</el-button>
      </el-row>
    </el-form>
    <el-table
      class="table"
      :data="tableData"
      :header-cell-style="{ 'text-align': 'center' }"
      :cell-style="{ 'text-align': 'center' }"
      style="width: 98.5%; margin-top: 30px; margin-left: 10px"
      highlight-current-row
    >
      <el-table-column type="index" label="序号" width="130">
        <template slot-scope="scope">
          {{ total - ((queryData.pageNo - 1) * queryData.pageSize) - scope.$index }}
        </template>
      </el-table-column>
      <el-table-column prop="mobile" label="手机号" />
      <el-table-column prop="ip" label="请求IP" />
      <el-table-column prop="verCode" label="短信验证码" />
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <!-- 0 成功  -1失败 -->
          <el-tag v-if="scope.row.status == '0'" type="success">成功</el-tag>
          <el-tag v-else type="danger">失败</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="发送时间" />
    </el-table>
    <!-- 分页 -->
    <el-pagination
      background
      :current-page="queryData.pageNo"
      :page-sizes="[15, 30, 50, 100, 200, total]"
      :page-size="queryData.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { get, post } from '@/utils/request'
const moment = require('moment')
export default {
  name: 'SmsSendRecord',
  data() {
    return {
      queryData: {
        pageSize: 15,
        pageNo: 1,
        model: {
          mobile: '',
          status: ''
        }
      },
      tableData: [],
      date: [],
      total: 0
    }
  },
  created() {
    this.getList()
  },
  methods: {
    search() {
      this.getList()
    },
    clear() {
      this.getList()
    },
    getList() {
      post('/admin/smsLog/page', this.queryData).then((res) => {
        this.total = res.data.data.total
        this.tableData = res.data.data.data
      })
    },
    handleSizeChange(val) {
      this.queryData.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.queryData.pageNo = val
      this.getList()
    }
  }
}
</script>
